import { gql } from "@apollo/client"
/// <summary>
///FOR THIS NO TOTAL COUNT IS NEEDED SINCE WE LIMIT THIS TO 2
/// </summary>
export const GET_LOCATION_CUSTOMFIELDS = gql`
query GetLocationCustomFields ($locationId:UUID!){
  customFields (locationId:$locationId){
    __typename
    id
    name
    type
    required
    description
  }
}`